<template>
    <d-card-body>
        <d-col class="d-flex">
            <img class="img-fluid network-logo" :src="affiliate.logo">
        </d-col>
        <div class="row">
            <div class="progress-text col-6">
                <h6 class="m-0 mt-5 text-left">
                    <u>1. Generate Postback URL</u>
                </h6>
            </div>
            <div class="progress-text col-6">
                <h6 class="m-0 mt-5 text-right">
                    2. Complete
                </h6>
            </div>
        </div>
        <d-progress :value="percent" :max="100" />
        <d-row class="d-flex justify-content-center">
            <d-col md="12" class="mt-2">
                <p>In order to process transactions from {{ affiliate.human_readable_name }} you need to generate a Postback URL by clicking on the button below. You need to set the Postback URL that is generated as Postback URL in your affiliate network account.</p>
            </d-col>
            <d-col lg="6" >
                <d-form id="networkForm">
                    <d-form-row>
                        <d-col md="8" class="form-group">
                            <d-input disabled type="text" v-model="postback" id="postback" />
                        </d-col>
                        <d-col md="12" class="form-group">
                            <button type="button" @click="generatePostback" class="btn btn-success btn-sm">Generate</button>
                            <button type="button" v-clipboard="() => postback" @click="showSuccess" class="btn btn-success btn-sm ml-2">Copy to Clipboard</button>
                        </d-col>
                        <d-col md="12" class="form-group d-flex justify-content-end">
                            <input @click="close" value="Next" type="button" class="btn btn-success">
                        </d-col>
                    </d-form-row>
                </d-form>
            </d-col>
        </d-row>
    </d-card-body>
</template>

<script>
    import { AffiliateNetworkService } from '@/main';
    import notification from '@/mixins/notification';

    export default {
        props: ['networkName', 'affiliate'],

        mixins: [notification],

        data() {
            return {
                postback: ' ',
                percent: 50
            }
        },

        methods: {
            showSuccess() {
                this.showNotification('success', 'Alert', 'Copied to clipboard!')
            },

            close() {
                this.chooseRedirectPath()
                this.$router.go()
            },

            chooseRedirectPath() {
                if (this.$route.name === "connect") {
                    this.$router.push({ name: 'add-network', params: { id: this.$route.params.websiteId }})
                    return
                }
                if (this.$route.name === "connect-network") {
                    this.$router.push({ name: 'network', params: { id: this.$route.params.websiteId }})
                    return
                }
                this.$router.push({ path: `/network/${this.$route.params.websiteId}`})
            },

            async generatePostback() {
                try {
                    const media = await AffiliateNetworkService.create([], this.$route.params.networkId, this.networkName, this.$route.params.websiteId, '')
                    this.postback = await AffiliateNetworkService.generatePostback(media.data.createMedia.id)
                    this.showNotification('success', 'Alert', 'Media successfully created!')
                } catch(e) {
                    this.showNotification('warn', 'We have a problem', 'Can not generate postback url')
                    console.log(e)
                }
            },
        }
    }
</script>
